import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import React from 'react';

class Link extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    action: PropTypes.any,
    icon: PropTypes.string,
    underline: PropTypes.bool,
  };

  render() {
    const {action, icon, label, underline} = this.props;
    let iconElement = !!icon ? <i className={icon} /> : null;

    return (
        <a className={(underline ? 'underline-link' : '') + ' custom-link'}
        onClick={action}>{iconElement}<FormattedMessage id={label}/></a>
    );
  }
}

export default Link;
